var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3V9",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V9",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5H31.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 6H7.5C5.8425 6 4.5 7.3425 4.5 9V28.5C4.5 30.1575 5.8425 31.5 7.5 31.5H28.5C30.1575 31.5 31.5 30.1575 31.5 28.5V9C31.5 7.3425 30.1575 6 28.5 6Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5195 19.0935C10.3125 19.0935 10.1445 19.2615 10.146 19.4685C10.146 19.6755 10.314 19.8435 10.521 19.8435C10.728 19.8435 10.896 19.6755 10.896 19.4685C10.896 19.2615 10.728 19.0935 10.5195 19.0935",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0195 19.0935C17.8125 19.0935 17.6445 19.2615 17.646 19.4685C17.646 19.6755 17.814 19.8435 18.021 19.8435C18.228 19.8435 18.396 19.6755 18.396 19.4685C18.396 19.2615 18.228 19.0935 18.0195 19.0935",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5195 19.0935C25.3125 19.0935 25.1445 19.2615 25.146 19.4685C25.146 19.6755 25.314 19.8435 25.521 19.8435C25.728 19.8435 25.896 19.6755 25.896 19.4685C25.896 19.2615 25.728 19.0935 25.5195 19.0935",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5195 25.0935C10.3125 25.0935 10.1445 25.2615 10.146 25.4685C10.146 25.6755 10.314 25.8435 10.521 25.8435C10.728 25.8435 10.896 25.6755 10.896 25.4685C10.896 25.2615 10.728 25.0935 10.5195 25.0935",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0195 25.0935C17.8125 25.0935 17.6445 25.2615 17.646 25.4685C17.646 25.6755 17.814 25.8435 18.021 25.8435C18.228 25.8435 18.396 25.6755 18.396 25.4685C18.396 25.2615 18.228 25.0935 18.0195 25.0935",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarIcon.04a7d0f5.svg";
export { ForwardRef as ReactComponent };